import script from "./SettingsNavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsNavItem.vue?vue&type=script&setup=true&lang=js"

import "./SettingsNavItem.vue?vue&type=style&index=0&id=f9c48176&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9c48176"]])

export default __exports__